/**
 * `/accounts/:accountId/assistants/:AssistantID/myassistant/knowledge` — the
 * only place the knowledge base is mounted (`AppRouter.tsx`, the `myassistant`
 * group; the sidebar and the agent modules link there). Anchored at both ends,
 * so the RTA knowledge (`/rta/knowledge`), the QA knowledge base
 * (`/qa/knowledge-base`) and anything nested below never match; a substring
 * test would also catch an id that happens to contain the segment.
 */
const KNOWLEDGE_ROUTE = /^\/accounts\/[^/]+\/assistants\/[^/]+\/myassistant\/knowledge\/?$/;

export function isKnowledgePath(pathname: string): boolean {
  return KNOWLEDGE_ROUTE.test(pathname);
}
